const filterCheckboxes = document.querySelectorAll('.js-filter-checkbox');
const modalFilterCheckboxes = document.querySelectorAll('.js-filter-checkbox-modal');

function submitFilters(filters) {
    const filterOptions = {};

    filters.forEach((checkbox) => {
        const filterType = checkbox.dataset.filter;

        if (checkbox.checked) {
            if (filterOptions[filterType]) {
                filterOptions[filterType] += `,${checkbox.value}`;
            } else {
                filterOptions[filterType] = checkbox.value;
            }
        }
    });

    if (document.querySelector('[name=q]').value) {
        filterOptions.q = document.querySelector('[name=q]').value;
    }

    let outUrl = `${`${window.location.protocol}//${window.location.host}${window.location.pathname}`}?`;

    Object.keys(filterOptions).forEach((key) => {
        outUrl += `${key}=`;
        outUrl += filterOptions[key];
        outUrl += '&';
    });

    window.location.href = outUrl;
}

function initFilters(filters) {
    filters.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
            submitFilters(filters);
        });
    });
}

if (filterCheckboxes.length) {
    initFilters(filterCheckboxes);
}

if (modalFilterCheckboxes.length) {
    initFilters(modalFilterCheckboxes);
}
